import { chain } from 'lodash';
import { GigData } from '@fiverr-private/seller_pages_toolbox';

const orderByPriceAndPro = (gigs: GigData[]) =>
    chain(gigs)
        .orderBy((gig) => gig.price_i, 'desc')
        .orderBy({ is_pro: true }, 'desc')
        .value();

export const orderGigs = (gigs: GigData[], relevantGigsOrder: number[] = []) => {
    const relevantGigs = chain(gigs)
        .filter((gig) => relevantGigsOrder.includes(gig.gig_id))
        .orderBy((gig) => relevantGigsOrder.indexOf(gig.gig_id), 'asc')
        .value();

    const commonGigs = gigs.filter((gig) => !relevantGigsOrder.includes(gig.gig_id));

    return [...relevantGigs, ...orderByPriceAndPro(commonGigs)];
};

export const isBrowser = () => typeof window !== 'undefined';

export const T_PREFIX = 'seller_page_perseus.professions_page.main_content';
